export default __webpack_public_path__ + "files/Know_the_Score-29e23863d1aac11fe964b50d0b0f172d.pdf";